import { createAction, props } from '@ngrx/store';
export const setPlotType = createAction('[Scatter Plot] Set Plot Type', props());
